module.exports = __webpack_public_path__ + "img/completion10.a3c173bc.svg";